import { render, staticRenderFns } from "./TransactionsHistoryExtra.vue?vue&type=template&id=5150cef0&scoped=true&"
import script from "./TransactionsHistoryExtra.vue?vue&type=script&lang=js&"
export * from "./TransactionsHistoryExtra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5150cef0",
  null
  
)

export default component.exports